





































































import { Component, Vue } from 'vue-property-decorator';
import CandidatePortalLogo from './../CandidatePortalLogo.vue';

@Component({
  name: 'TargetRecruitHeader',
  components: {
    CandidatePortalLogo,
  },
})
export default class TargetRecruitHeader extends Vue {
  closePage() {
    this.$router.push('/home');
  }
}
